<template>
  <div>
    <search abc="找大会, 找视频"></search>
    <div class="bars">
      0000000000000000000000000
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        // source_url:''
      }
    },
    components: {
      // pw:'',
      // isWeiXin:'',
      // uid:'',
      // ip:'',
      // nick_name:'',
      // current_url:'',
    },
    created() {
      this.removefun();
      // this.get_uid();
    },
    // beforeRouteEnter(to, from, next){
    //   next(vm =>{
    //     vm.source_url=from.fullPath;
    //   })
    // },
    mounted() {
    },
    methods: {
      removefun(){
        localStorage.removeItem('uid');
        localStorage.removeItem('nick_name');
      }
      
      // test_wechat() {
      //   if(this.isWeiXin==true){
      //     if(this.uid==undefined){
      //       var locationUrl = window.location.href;
      //       var newurl=locationUrl.replace(/http:\/\/[^\/]*/, "");
      //       this.setBase(newurl);
      //       newurl=this.pw;
      //       var jiami_url='http://www.itdks.com/Home/auth/authBack?params='+newurl;
      //       var weixin_encodeURI='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdb7ae4d519952e9a&redirect_uri='+jiami_url+'&response_type=code&scope=snsapi_userinfo&state=itdks#wechat_redirect';
      //       window.location.href=weixin_encodeURI;
      //     }
      //     else{
      //       return
      //     }
      //   }
      // },
      // get_uid(){
      //   this.$axios.get('http://www.itdks.com/Home/Auth/getWxUid').then(res => {
      //     if(res.data.status==1){
      //       this.isWeiXin=res.data.data.isWeiXin;
      //       this.ip=res.data.data.ip;
      //       this.nick_name=res.data.data.nick_name;
      //       this.uid=this.$route.query.uid;
      //       this.current_url=window.location.href;
      //       this.send_nick_name();
      //       this.test_wechat();
      //     }
      //     else{
      //       console.log(res.data.msg);
      //     }
      //   })
      // },
      // send_nick_name(nick_name){
      //   if(this.source_url=='/'){
      //     this.source_url='';
      //   }
      //   this.$axios.post('http://www.apm-cash.com/Home/Statistics/addUserTodayView', {
      //     uid:this.uid,
      //     current_url:this.current_url,
      //     source_url:this.source_url,
      //     nick_name:this.nick_name,
      //   })
      //   .then(function (response) {
      //     console.log('请求成功');
      //   })
      //   .catch(function (error) {
      //     console.log('请求失败');
      //   });
      // },
      // setBase(url){
      //   let Base64 = require("js-base64").Base64;
      //   this.pw = Base64.encode(url);
      // },
    }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Live/test_wechat.vue